import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import logo from "../logo.png"
import IdleTimeOutHandler from './idleTimeContainer';
import axios from "../axiosInstance";
import { useCookies } from 'react-cookie';
export default function SidebarUserAgency() {
    const OpSidebar = () => {
        const body = document.querySelector("body"),
        sidebar = body.querySelector(".sidebar"),
        toggle = body.querySelector(".toggle"),
        searchBtn = body.querySelector(".search-box"),
        modeSwitch = body.querySelector(".toggle-switch"),
        modeText = body.querySelector(".mode-text");

        if (toggle != null) {
            toggle.addEventListener("click", () => {
                sidebar.classList.toggle("close")
            });
        }
        if (modeSwitch != null) {
            modeSwitch.addEventListener("click", () => {
                body.classList.toggle("dark")
                if (body.classList.contains("dark")) {
                    modeText.innerHTML = "Light Mode"
                } else {
                    modeText.innerHTML = "Dark Mode"
                }
            })
        }
        if (searchBtn != null) {
            searchBtn.addEventListener("click", () => {
                sidebar.classList.remove("close")
            })
        }
    }
    const [cookies, setCookies] = useCookies(['cookieConsent']);

    const burl = process.env.REACT_APP_B_URL
    const postUserLog = async (url, action, code) => {
        await axios.get("https://api.ipify.org/?format=json")
            .then(async (res) => {
                console.log('------------------------------')
                console.log(res)
                await axios.post(url,
                    {
                        "fkIdStaff": sessionStorage.getItem('idUser'),
                        "userAction": action,
                        "code": code,
                        "iPaddress": res.data.ip == undefined ? res.data.ip : '0.0.0.0'
                    }, {

                    'Content-Type': 'application/json',
                    accept: 'application/json',
                }).then((response) => {
                    console.log(response)
                }).catch(error => {
                    console.log(error)
                })
            })
            .catch(err => console.log(err))
    }

    const axiosInstance = axios.create({
          withCredentials: true,
        })

    const [isActive, setIsActive] = useState(true);
    const navigate = useNavigate();
    const logOut = async () => {
        console.log('Logout')
        await axiosInstance.get(burl+"/agency-user/logout").catch(
            rsp=>{
                console.log(rsp)
            }
        ).then(err=>{
            console.error(err)
        })
        //await postUserLog(burl + "/userLogs/addUserLogs", 'Déconnecxion', '');
        sessionStorage.removeItem('name', '');
        sessionStorage.removeItem('access_token');
        sessionStorage.removeItem('idAgency');
        if (cookies.cookieConsent) {
            setCookies('token', '', { path: '/agency-user-login' })
        }

        navigate("/agency-user-login");
    }

    return (
        <>
            <nav className="sidebar close">
                <header>
                    <div className="image-text">
                        <span className="image">
                            <img src={logo} alt="img" width="150%" className='logo' />
                        </span>
                        <div className=" text header-text">
                            <span className="name">Univer des solutuions numeriques</span>
                            <span className="prfession">Web Developper</span>
                        </div>
                    </div>
                    <i className='bx bx-chevron-right toggle' onClick={OpSidebar}></i>
                </header>
                <div className="menu-bar">
                    <div className="menu">
                        <ul className="menu-link">
                            <li className="search-box" onClick={OpSidebar}>
                                <i className='bx bx-search icon'></i>
                                <input type="text" placeholder="Search..." className="text" />
                            </li>
                            <li className={window.location.pathname == '/masterDepositByAgency' ? "open nav-link-my" : "nav-link-my"}>
                                <Link to="/masterDepositByAgency">

                                    <i className='bx bx-home-alt icon' onClick={OpSidebar}></i>
                                    <span className="text nav-text">Accueil</span>
                                </Link>
                            </li>

                            <li className={window.location.pathname == '/agentsOfAgency' ? "open nav-link-my drop-container" : "nav-link-my drop-container"}>
                                <Link to="/agentsOfAgency">
                                    <i className='bx bx-group icon' onClick={OpSidebar}></i>
                                    <span className="text nav-text">Agents</span>
                                </Link>

                            </li>

                        </ul>
                    </div>
                    <div className="bottom-content">
                        <li className="">
                            <a href="#" onClick={() => logOut()}>
                                <i className='bx bx-log-out icon'></i>
                                <span className="text nav-text">Logout</span>
                            </a>
                        </li>
                        <li className="mode">
                            <div className="moon-sun">
                                <a href="#">
                                    <i className='bx bx-moon icon moon'></i>
                                    <i className='bx bx-sun icon sun'></i>
                                </a>
                            </div>
                            <span className="mode-text text">Dark Mode</span>
                            <div className="toggle-switch" onClick={() => OpSidebar()}>
                                <span className="switch"></span>
                            </div>
                        </li>
                    </div>
                </div>


            </nav>
            <IdleTimeOutHandler onIdle={() => { logOut() }} onActive={() => setIsActive(true)} ></IdleTimeOutHandler>

        </>
    )
}
